/**
 * Shared stroke/background colors for RPA write-back status icons in table cells.
 */
export const STATUS_COLORS = {
  SUCCESS: { stroke: "#005D49", background: "#E6F3F0" },
  ERROR: { stroke: "#CD0202", background: "#FAE6E6" },
  IN_PROGRESS: { stroke: "#0066E0", background: "#EAF2FF" },
  QUEUED: { stroke: "#4b00cc", background: "#4b00cc" },
  DEFAULT: { stroke: "#5C5C5C", background: "#F5F5F5" },
  /** Manual follow-up required (e.g. write-back needs human action). */
  MANUAL_REQUIRED: { stroke: "#EF6C00", background: "#FFF3E0" },
};
